// apps/client/src/engine/pageRenderer.ts (title screen, 2026-10-05) — the page's one WebGL renderer, on the #world canvas. The title's
// showcase town (title/stage.ts) draws with it first; the Game takes it over on the first town entry (game.attach), so the page keeps a
// single WebGL context and the town reuses the shader programs the title already compiled.
import { createRenderer, type Renderer } from './renderer';
import type { QualityLevel } from './quality';

let shared: Renderer | null = null;
/** #world (index.html), or a new canvas put first in the body when a test page has none. */
export function pageCanvas(): HTMLCanvasElement {
  let canvas = document.getElementById('world') as HTMLCanvasElement | null;
  if (!canvas) { canvas = document.createElement('canvas'); canvas.id = 'world'; document.body.prepend(canvas); }
  return canvas;
}
/** The renderer, created at `quality` on first use; later callers get the same one (and set its quality themselves). */
export function pageRenderer(quality: QualityLevel): Renderer { return (shared ??= createRenderer(pageCanvas(), quality)); }
/** The renderer if one was made, without making it. */
export function peekPageRenderer(): Renderer | null { return shared; }
